/*
 * @Author: ht 1724552153@qq.com
 * @Date: 2024-08-05 13:56:40
 * @LastEditors: ht 1724552153@qq.com
 * @LastEditTime: 2025-07-08 09:36:23
 * @FilePath: \jisuapp_webapp\src\chatgpt-page\component\TextAnimationPc\TextAnimationPc.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component,useState  } from "react";
import { appMethod as app } from '@utils/app';
import { Toast, Icon } from 'antd-mobile';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

import "./TextAnimationPc.less";
const GPTModal = {
  '0': 'GPT-3.5',
  '1': 'GPT-4',
  '2': '文心一言-4.0',
  '3': 'GPT-4omini',
  '4': '通义千问',
  '5': 'kimi',
  '6': 'GPT-4o',
  '7': '字节豆包',
  '8': '百川智能',
  '9': 'GPT-o1-preview',
  '10': 'GPT-o1-mini',
  '11': '腾讯混元',
  '12': '讯飞星火-Max',
  '13': 'Azure-OpenAI',
  '14': 'deepseek（官网）',
  '15': 'deepseek（腾讯云版本）',
  '16': 'UI TARS',
  '17': 'GPT-o3-mini',
  '18': 'GPT-o4-mini',
  '19': '通义千问3',
}
class TextAnimationPc extends Component {
  state = {
    displayText: "",
    userInfo : app.getUserInfo(),
    generateing: false,
    timer: null,
    chunks:[],
    previewUrl: '',
    files: [],
    // 深度思考
    reasoningTimer: null,
    displayDeepText: ""
  };
  componentDidMount() {
    const { text, direction, isHistory,chunks,reference_url, files,showDeep,reasoningContent,id } = this.props.data;
    // let currentIndex = 0;
    if (direction != "reply" || isHistory) {
      this.setState({
        displayText: text,
        chunks:chunks,
        files: files || []
      });
      return;
    }
    // 深度思考逻辑
    if(showDeep == 1 && reasoningContent  && reasoningContent != ''){
      this.startReasoningContentPolling(reasoningContent, () => {
        // 深度思考内容轮询完成后的回调
        this.props.showDeepFinshed(id)
        this.startTextPolling(text,chunks); // 开始轮询主文本
      })
    }else{
      this.startTextPolling(text,chunks); // 开始轮询主文本
    }
   
    // const intervalId = setInterval(() => {
    //   if (currentIndex < text.length) {
    //     this.setState((prevState) => ({
    //       displayText: prevState.displayText + text[currentIndex],
    //     }));
    //     currentIndex++;
    //     // if(text[currentIndex] == '\n' || currentIndex%44 == 0){  // 换行时
    //       this.toBoxBottom();
    //     // }
    //   } else {
    //     clearInterval(intervalId);
    //     this.endQuestion();
    //     this.setState({
    //       generateing: false
    //     })
    //   }
    // }, 40);
    // this.setState({
    //   timer: intervalId
    // })
    
  }
  // 轮询深度思考内容
  startReasoningContentPolling = (content, callback) => {
    let currentIndex = 0;
    const intervalId = setInterval(() => {
        if (currentIndex < content.length) {
            this.setState((prevState) => ({
                displayDeepText: prevState.displayDeepText + content[currentIndex],
            }));
            currentIndex++;
            this.toBoxBottom();
        } else {
            clearInterval(intervalId);
            callback(); // 轮询完成后执行回调
        }
    }, 40);
    
    this.setState({ reasoningTimer: intervalId });
  }

  // 轮询主文本内容
  startTextPolling = (text,chunks) => {
    let currentIndex = 0;
    const intervalId = setInterval(() => {
      if (currentIndex < text.length) {
        this.setState((prevState) => ({
          displayText: prevState.displayText + text[currentIndex],
          chunks:chunks
        }));
        currentIndex++;
        // if(text[currentIndex] == '\n' || currentIndex%44 == 0){  // 换行时
          this.toBoxBottom();
        // }
      } else {
        clearInterval(intervalId);
        this.endQuestion();
        this.setState({
          generateing: false
        })
      }
    }, 40);
    this.setState({
      timer: intervalId
    })
  }
  componentWillUnmount() {
    // clearInterval(this.intervalId);
    clearInterval(this.state.timer);
    clearInterval(this.state.reasoningTimer);
  }
   //停止生成
   stopGenerate = () => {
    clearInterval(this.state.timer);
    clearInterval(this.state.reasoningTimer);
    this.endQuestion();
  }

  // 正则表达式 替换#标识符
  replaceTextWithComponent = (text, chunks, url) => {
    const regex = /`?##(\d+|\{\d+\})(##|\$\$)`?/g;
    const parts = [];
    let lastIndex = 0;
    let tooltipIndex = 0;
  
    text.replace(regex, (match, p1, p2, offset) => {
      // 添加文本部分
      if (offset > lastIndex) {
        parts.push(text.substring(lastIndex, offset));
      }
  
      let index;
      if (p1.startsWith('{')) {
        index = parseInt(p1.slice(1, -1), 10) - 1;
      } else {
        index = parseInt(p1, 10) - 1;
      }
  
      const chunk = chunks[index] || '';
  
      // 添加图标组件
      if (chunk) {
        parts.push(
          <Tooltip
            key={`tooltip-${tooltipIndex++}-${index}-${p1}`}
            placement="top"
            overlay={
              <div className="custom-tooltip-box">
                <div className="custom-tooltip-wrapper">
                  <span>{chunk.content_with_weight}</span>
                </div>
                <div className="custom-tooltip">
                  <img
                    src="https://test2.zhichiwangluo.com/static/management/assets/img/ai/learn-7.png"
                    alt=""
                  />
                  <span
                    onClick={() => this.handleFileNameClick(chunk.docnm_kwd)}
                    style={{ cursor: 'pointer' }} // 添加手势样式，让用户知道这是可点击的
                  >
                    {chunk.file_name}
                  </span>
                </div>
              </div>
            }
            trigger={['hover']}
          >
            <Icon type="question-circle" title="这是一个提示信息" className="icon-container" />
          </Tooltip>
        );
      }
  
      lastIndex = offset + match.length;
    });
  
    // 添加剩余文本部分
    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }
  
    return parts;
  };

    // 点击链接事件
    handleFileNameClick = (docnmkwd) => {
      console.log(docnmkwd);
      app.sendRequest({
        url: '/index.php?r=ChatAI/GetFileUrl',
        hideLoading: true,
        method: 'POST',
        data: {
          app_id: app.getAppId(),
          file_name: docnmkwd
        },
        success: function (res) {
          if (res.status === 0) {
            const fileUrl = res.data; 
            // 使用 fetch 请求文件内容
            fetch(fileUrl)
              .then(response => response.blob())
              .then(blob => {   
                // 创建一个对象 URL 用于下载
                const objectUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = objectUrl;
                a.download = docnmkwd; // 设置下载的文件名
               // 触发点击事件以下载文件
                a.click();
                // 释放对象 URL
                URL.revokeObjectURL(objectUrl);
              })
              .catch(error => {
                console.error('Error fetching the file:', error);
              });
        }
        }
      });
    };


  // 复制东西到剪切板
  setClipboardData = e => {
    let content = e.currentTarget.dataset.content
    app.setClipboardData({
      data: content
    })
    Toast.info('复制完成',1);
  }

  // 存储记忆
  // setStorageData = ()=>{
  //   this.props.setStorageData()
  // }

  // // 单选按钮
  // checkboxChange = e =>{
  //   let checked = e.target.checked;
  //   this.props.checkboxChange(this.props.data.id,checked)
  // }


  toPage = () => {
    app.turnToPage('userCenterComponentPage');
  }
  sendQues = (e) => {
    let content = e.currentTarget.dataset.content;
    this.props.againSend(content, true);
  }
  againSend = (e) => {
    let content = e.currentTarget.dataset.content
    this.props.againSend(content);
  }
  toBoxBottom = () => {
    this.props.toBoxBottom();
  }
  endQuestion = () => { 
    this.props.endQuestion();
  }

  showDeepChange = (e)=>{
    let ids = e.currentTarget.dataset.id
    this.props.showDeepChange(ids)
  }
  render() {
    const { displayText , userInfo, generateing,chunks, files, displayDeepText} = this.state;
    const { direction, isLoading, err, type, showDeep,id,showDeepContent,reasoningFinsh,reasoningContent, quesList,reference_url,text} = this.props.data;
    // const { isStorageVisible } = this.props
    if (direction == "reply") {
      return (
        <div className="chat_pc">
          <div className="chat-bubble-left">
          {/* {!isStorageVisible && <input type="checkbox" checked={isStorageFlag} onChange={this.checkboxChange} />} */}
            <div className="row">
              <img className="headimg" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/log2.png" alt="" />
              <div className="chat-bubble-item">
                {/* 深度解析回答 */}  
                {showDeep == 1 && (
                  <div className={`${!showDeepContent ? "chat-bubble-deep" : "chat-bubble-deepdowan"}`}>
                    <div className="chat-deep-title">
                      <span>{reasoningFinsh ? '已深度思考' : '正在深度思考中'}</span>
                      {!showDeepContent && ( <label data-id={id}  onClick={this.showDeepChange} className={`ico-moon icon-uparrow`}></label>)}
                      {showDeepContent && ( <label data-id={id} onClick={this.showDeepChange} className={`ico-moon icon-downarrow`}></label>)}
                    </div>
                    {
                      !showDeepContent && (
                        <div className="chat-deep-content">
                            {displayDeepText}
                        </div>
                      )
                    }
                  </div>
                )}
                {/* 正常ai回答内容 没有深度解析的情况 */}
                  {
                    showDeep == 0 && (
                      <div className="chat-bubble-content">
                      <div>{this.replaceTextWithComponent(displayText,chunks,reference_url)}</div>
                      { displayText != '' && 
                      <div className="con_operate">
                        {/* <div>重新生成<label className='ico-moon icon-load'></label></div> */}
                        <label className='ico-moon icon-copy' onClick={this.setClipboardData} data-content={displayText}></label>
                      </div>
                      }
                      {
                        !!type == true &&   <div className="mode">{GPTModal[type]}</div>
                      }
                    </div>
                    )
                  }
                  {/* 正常ai回答内容 有深度解析的情况 而且内容不是是空的 */}
                  {
                  showDeep == 1 && reasoningFinsh && (
                    <div className="chat-bubble-content">
                    <div>{this.replaceTextWithComponent(displayText,chunks,reference_url)}</div>
                    { displayText != '' && 
                    <div className="con_operate">
                      {/* <div>重新生成<label className='ico-moon icon-load'></label></div> */}
                      <label className='ico-moon icon-copy' onClick={this.setClipboardData} data-content={displayText}></label>
                    </div>
                    }
                    {
                      !!type == true &&   <div className="mode">{GPTModal[type]}</div>
                    }
                  </div>
                  )
                }
              </div>
            </div>
            {/* <img className="copyimg" onClick={this.setClipboardData} data-content={displayText} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/copy2.png" alt="" /> */}
          </div>
          { quesList && quesList.length > 0 && <div className="ques_list">
            {quesList.map((q, i) => {
              return (<p className="ques_item" key={i} onClick={this.sendQues} data-content={q}>{q}</p>)
            })}
          </div>} 
          {generateing == true && 
          <div className="stop_btn" onClick={this.stopGenerate}>
            <label className='ico-moon icon-stop'></label>
            <span>停止回答</span>
          </div>
          }
        </div>
      );
    }
    return (
      <div className="chat_pc">
        <div className="chat-bubble-right">
         {/* {!isStorageVisible && <input className="right_ipt" type="checkbox" checked={isStorageFlag} />} */}
          {/* {!isLoading && !err && (<img className="copyimg" onClick={this.setClipboardData} data-content={displayText} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/copy2.png" alt="" />)} */}
          <div className="row">
            <div className="chat-bubble-content">{displayText}
            <div className="copy_box">   
              <div className="copy">
                <label className='ico-moon icon-copy' onClick={this.setClipboardData} data-content={displayText}></label>
                <div className="copy_dsc">复制</div>
              </div>
            </div>
            {/* <div className="storage_box">   
              <div className="storage" onClick={this.setStorageData}>
                <img   src="//cdn.jisuapp.cn/static/management/assets/img/ai/basic/term21.png" alt="" />
                <div className="storage_dsc">记忆</div>
              </div>
            </div> */}
            </div>
            <img className="headimg" onClick={this.toPage} src={userInfo.cover_thumb?userInfo.cover_thumb:'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt="" />
          </div>
        </div>
        <div className="file_list">
        {files.map((item, index) =>
          <div className='file_item'>
            {
              item.type === 'image' &&
              <img className='icon_file' src={ item.file_url } alt="" />
            }
            {
              item.type !== 'image' &&
              <img className='icon_file' src={ 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_' + item.file_type + '.png' } alt="" />
            }
            <div className='file_dsc'>
              <span className='file_name'>{ item.name }</span>
              <span className='file_state'>{ item.file_type }，{ item.size }</span>
            </div>
          </div>
        )}
        </div>
        <div className="ques_status">
          {isLoading && <Icon type="loading" className="loadicon" />}
          {err && (<div>
          <img onClick={this.againSend} data-content={displayText} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/error.png" alt="" />
          发送失败
          </div>)}
        </div>
      </div>
    );
   
  }
}
export default TextAnimationPc;



// WEBPACK FOOTER //
// ./src/chatgpt-page/component/TextAnimationPc/TextAnimationPc.jsx